import { render } from "./CourseStart.vue?vue&type=template&id=5947bdd6&scoped=true"
import script from "./CourseStart.vue?vue&type=script&lang=js"
export * from "./CourseStart.vue?vue&type=script&lang=js"

import "./CourseStart.vue?vue&type=style&index=0&id=5947bdd6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5947bdd6"

export default script